const cloneShortcutItems = (items) =>
  [-1, 0, 1].flatMap((group) =>
    items.map((item, index) => ({
      item,
      key: `${group}-${index}-${item.id || item.imgUrl || item.text || "shortcut"}`,
    })),
  );

export default {
  data() {
    return {
      shortcutLoopActive: false,
      shortcutScrollable: false,
      canScrollShortcutsLeft: false,
      canScrollShortcutsRight: false,
    };
  },
  computed: {
    shortcutCarouselItems() {
      const items = Array.isArray(this.navList) ? this.navList : [];
      if (!this.shortcutLoopActive) {
        return items.map((item, index) => ({
          item,
          key: `0-${index}-${item.id || item.imgUrl || item.text || "shortcut"}`,
        }));
      }
      return cloneShortcutItems(items);
    },
  },
  watch: {
    navList() {
      this.refreshShortcutCarousel();
    },
  },
  mounted() {
    this.refreshShortcutCarousel();
    window.addEventListener("resize", this.refreshShortcutCarousel);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.refreshShortcutCarousel);
    if (this._shortcutScrollFrame) {
      cancelAnimationFrame(this._shortcutScrollFrame);
    }
  },
  methods: {
    getShortcutGroupWidth(viewport) {
      const itemCount = this.navList.length;
      const items = viewport.querySelectorAll(".shortcut-item");
      if (items.length >= itemCount * 2) {
        return items[itemCount].offsetLeft - items[0].offsetLeft;
      }
      return viewport.scrollWidth / 3;
    },
    jumpShortcutScroll(viewport, left) {
      this._shortcutJumping = true;
      viewport.style.scrollBehavior = "auto";
      viewport.scrollLeft = left;
      requestAnimationFrame(() => {
        viewport.style.scrollBehavior = "";
        requestAnimationFrame(() => {
          this._shortcutJumping = false;
        });
      });
    },
    refreshShortcutCarousel() {
      this.shortcutLoopActive = false;
      this.shortcutScrollable = false;
      this.canScrollShortcutsLeft = false;
      this.canScrollShortcutsRight = false;

      this.$nextTick(() => {
        const viewport = this.$refs.shortcutViewport;
        if (!viewport || this.navList.length < 2) return;
        if (viewport.scrollWidth <= viewport.clientWidth + 1) return;

        this.shortcutLoopActive = true;
        this.shortcutScrollable = true;
        this.canScrollShortcutsLeft = true;
        this.canScrollShortcutsRight = true;
        this.$nextTick(() => {
          const groupWidth = this.getShortcutGroupWidth(viewport);
          this.jumpShortcutScroll(viewport, groupWidth);
        });
      });
    },
    updateShortcutScrollState() {
      if (
        !this.shortcutLoopActive ||
        this._shortcutJumping ||
        this._shortcutScrollFrame
      ) {
        return;
      }
      this._shortcutScrollFrame = requestAnimationFrame(() => {
        this._shortcutScrollFrame = null;
        const viewport = this.$refs.shortcutViewport;
        if (!viewport || this._shortcutJumping) return;

        const groupWidth = this.getShortcutGroupWidth(viewport);
        if (!groupWidth) return;
        if (viewport.scrollLeft < groupWidth * 0.5) {
          this.jumpShortcutScroll(
            viewport,
            viewport.scrollLeft + groupWidth,
          );
        } else if (viewport.scrollLeft > groupWidth * 1.5) {
          this.jumpShortcutScroll(
            viewport,
            viewport.scrollLeft - groupWidth,
          );
        }
      });
    },
    scrollShortcuts(direction) {
      const viewport = this.$refs.shortcutViewport;
      if (!viewport || !this.shortcutLoopActive) return;
      const items = viewport.querySelectorAll(".shortcut-item");
      const itemStep =
        items.length > 1
          ? Math.abs(items[1].offsetLeft - items[0].offsetLeft)
          : viewport.clientWidth;
      viewport.scrollBy({
        left: direction * itemStep,
        behavior: "smooth",
      });
    },
  },
};
